const boo = (value) => {
    
    if( value !== false) {
        
        return true

    } else {

        return false
        
    }

}

export default boo